import { API } from '@Providers';

export default async function() {
  const endpoint = '/api/shelter/profile/get';

  return API({endpoint});
}